import React from 'react';

interface Props {
  svg: string;
  width?: number;
  maxWidth?: number;
  height?: number;
  maxHeight?: number;
  testId?: string;
}

const CustomSvg = ({
  svg,
  width,
  height,
  maxWidth,
  maxHeight,
  testId,
}: Props) => (
  <div
    style={{ alignContent: 'center', width, height, maxWidth, maxHeight }}
    dangerouslySetInnerHTML={{ __html: svg }}
    data-testid={testId}
  />
);

export default CustomSvg;
